import ArrowRightAltIcon from "@mui/icons-material/ArrowRightAlt";
import ForwardToInboxOutlinedIcon from "@mui/icons-material/ForwardToInboxOutlined";
import LocalPrintshopIcon from "@mui/icons-material/LocalPrintshop";
import {
  Box,
  CircularProgress,
  Divider,
  IconButton,
  Paper,
  Skeleton,
} from "@mui/material";
import React, { Fragment, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";
import PageTitle from "../../../components/pageTitle";
import { API } from "../../../scripts/api";
import axiosInstance from "../../../scripts/axiosInspector";
import ProductCart from "./create/productCart";
const PriviewInvoice = () => {
  const [currentStep, setCurrentStep] = useState(1);
  const [data, setData] = useState({});
  const [loading, setLoading] = useState(false);
  const CurrentCompany = useSelector((state) => state.CurrentCompany);
  const { company } = CurrentCompany;
  const userLogin = useSelector((state) => state.userLogin);
  const { userInfo } = userLogin;
  const navigate = useNavigate();
  const [seleted, setSeleted] = useState([]);
  const dispatch = useDispatch();
  const [loadingSumbit, setLoadingSumbit] = useState(false);
  const [currencyOption, setCurrencyOption] = useState([]);
  const [render, setRender] = useState(1);
  const { id } = useParams();
  useEffect(() => {
    if (!id) return;
    setLoading(true);

    axiosInstance
      .get(
        API.int.getData +
          `?guidStateRecNo=${company?.guidRecNo}&guidRecNo=${id}`,
        {
          headers: {
            Authorization: `Bearer ${userInfo?.token}`,
            "Cache-Control": "no-cache",
            Pragma: "no-cache",
            Expires: "0",
            "Accept-Language": "fa-IR",
            chHostName: process.env.REACT_APP_CHHOSTNAME,
          },
        }
      )
      .then((res) => {
        setData({
          ...res?.data?.data?.headerInfo,
          ...res?.data?.data?.header,

          dInvoiceDate: new Date(
            new Date(res?.data?.data?.header?.dInvoiceDate).toUTCString()
          ),
        });
        var temp = [];
        res?.data?.data?.details?.map((item) => {
          temp.push({ ...item, prev: true });
        });
        setSeleted(temp);
        setLoading(false);
      })
      .catch((err) => {
        setLoading(false);
      });
  }, [id, render]);
  useEffect(() => {
    if (
      currencyOption.length === 0 &&
      data.chInvoicePatternCode === "CurrSale"
    ) {
      axiosInstance
        .get(API.public.currency + `?guidStateRecNo=${company?.guidRecNo}`, {
          headers: {
            Authorization: `Bearer ${userInfo?.token}`,
            "Cache-Control": "no-cache",
            Pragma: "no-cache",
            Expires: "0",
            "Accept-Language": "fa-IR",
            chHostName: process.env.REACT_APP_CHHOSTNAME,
          },
        })
        .then((res) => {
          setCurrencyOption(res?.data?.data);
          setLoading(false);
        })
        .catch((err) => {
          setLoading(false);
        });
    }
  }, [data]);
  const handleSms = () => {
    setLoadingSumbit(true);
    axiosInstance
      .get(
        API.int.sendSms +
          `?guidStateRecNo=${company?.guidRecNo}&guidRecNo=${id}`,
        {
          headers: {
            Authorization: `Bearer ${userInfo?.token}`,
            "Cache-Control": "no-cache",
            Pragma: "no-cache",
            Expires: "0",
            "Accept-Language": "fa-IR",
            chHostName: process.env.REACT_APP_CHHOSTNAME,
          },
        }
      )
      .then((res) => {
        setLoadingSumbit(false);

        if (res?.data?.isSuccess) {
          toast.success("پیامک با موفقیت ارسال شد");
        } else {
          toast.error(res?.data?.message);
        }
      })
      .catch((err) => {
        setLoadingSumbit(false);
      });
  };
  return (
    <>
      {" "}
      <PageTitle
        broadCrumb={[
          {
            title: "فروش",
            path: "/sell",
          },
          {
            title: "صورت حساب ",
            path: "/sell/invoice",
          },
        ]}
        title={"چاپ صورت حساب "}
      />{" "}
      <Paper
        sx={{ zIndex: 9, position: "relative" }}
        className="mx-3 my-5 border py-3 px-3 relative z-50"
        elevation={1}
      >
        {/* part 1 */}
        <div className="flex justify-between items-center my-1">
          <IconButton>
            <ArrowRightAltIcon
              onClick={() => {
                navigate("/sell/invoice/");
              }}
              color="primary"
            />
          </IconButton>
          <div className="flex gap-2 items-center">
            <IconButton>
              {loadingSumbit ? (
                <CircularProgress size={19} />
              ) : (
                <ForwardToInboxOutlinedIcon
                  onClick={() => {
                    handleSms();
                  }}
                  color="primary"
                />
              )}{" "}
            </IconButton>
            <IconButton>
              <LocalPrintshopIcon
                onClick={() => {
                  window.open(data.chPrintURL, "_blank");
                }}
                color="primary"
              />
            </IconButton>
          </div>
        </div>
        {data.guidBuyerRecNo && (
          <div className="flex flex-col gap-4 relative z-50">
            <div className="sm:grid sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 flex flex-col gap-4">
              <div className="sm:col-span-2  md:col-span-3 my-4  lg:col-span-4">
                <Divider>
                  <h2 className="text-base font-bold text-center text-main">
                    اطلاعات مشتری{" "}
                  </h2>
                </Divider>
              </div>
              {company?.chBusinessTypeCode === "Restaurant" && (
                <>
                  {" "}
                  {data.chBuyerSaleSoftID && (
                    <div className="flex items-center gap-3">
                      <span className="text-xs">شماره فیش: </span>
                      <span className="text-sm font-bold">
                        {data.intReceiptNumber}
                      </span>
                    </div>
                  )}{" "}
                  {data.chBuyerSaleSoftID && (
                    <div className="flex items-center gap-3">
                      <span className="text-xs">شماره میز: </span>
                      <span className="text-sm font-bold">
                        {data.chTableNumber}
                      </span>
                    </div>
                  )}{" "}
                  {data.chBuyerSaleSoftID && (
                    <div className="flex items-center gap-3">
                      <span className="text-xs">تعداد نفرات: </span>
                      <span className="text-sm font-bold">
                        {data.tintPeopleCount}
                      </span>
                    </div>
                  )}
                </>
              )}
              {data.chBuyerSaleSoftID && (
                <div className="flex items-center gap-3">
                  <span className="text-xs">کد: </span>
                  <span className="text-sm font-bold">
                    {data.chBuyerSaleSoftID}
                  </span>
                </div>
              )}
              {data.chBuyerTypeName && (
                <div className="flex items-center gap-3">
                  <span className="text-xs">نوع: </span>
                  <span className="text-sm font-bold">
                    {data.chBuyerTypeName}
                  </span>
                </div>
              )}
              {data.chBuyerName && (
                <div className="flex items-center gap-3">
                  <span className="text-xs"> عنوان: </span>
                  <span className="text-sm font-bold">{data.chBuyerName}</span>
                </div>
              )}
              {data.chBuyerMobile && (
                <div className="flex items-center gap-3">
                  <span className="text-xs"> تلفن همراه : </span>
                  <span className="text-sm font-bold">
                    {data.chBuyerMobile}
                  </span>
                </div>
              )}
              {data.chBuyerEconomicCode && (
                <div className="flex items-center gap-3">
                  <span className="text-xs"> شناسه اقتصادی: </span>
                  <span className="text-sm font-bold">
                    {data.chBuyerEconomicCode}
                  </span>
                </div>
              )}
              {data.chBuyerNationalID && (
                <div className="flex items-center gap-3">
                  <span className="text-xs"> شناسه / کد ملی : </span>
                  <span className="text-sm font-bold">
                    {data.chBuyerNationalID}
                  </span>
                </div>
              )}
            </div>
          </div>
        )}
        <div className="flex flex-col gap-4 relative z-50">
          <div className="sm:grid sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 flex flex-col gap-4">
            <div className="sm:col-span-2  md:col-span-3 my-4  lg:col-span-4">
              <Divider>
                <h2 className="text-base font-bold text-center text-main">
                  صورتحساب فروش
                </h2>
              </Divider>
            </div>
            <div className="flex items-center gap-3">
              <span className="text-xs"> نوع صورتحساب : </span>
              {loading ? (
                <Skeleton width={100}></Skeleton>
              ) : (
                <span className="text-sm font-bold">
                  {
                    OPTIONS.types?.find(
                      (item) => item.id === data.chInvoiceTypeCode
                    )?.title
                  }
                </span>
              )}
            </div>
            <div className="flex items-center gap-3">
              <span className="text-xs"> الگوی صورتحساب : </span>
              {loading ? (
                <Skeleton width={100}></Skeleton>
              ) : (
                <span className="text-sm font-bold">
                  {
                    OPTIONS.pattern1?.find(
                      (item) => item.id === data.chInvoicePatternCode
                    )?.title
                  }
                </span>
              )}
            </div>
            <div className="flex items-center gap-3">
              <span className="text-xs"> روش صورتحساب : </span>
              {loading ? (
                <Skeleton width={100}></Skeleton>
              ) : (
                <span className="text-sm font-bold">
                  {
                    OPTIONS.paymentType?.find(
                      (item) => item.id === data.chSettlementMethodCode
                    )?.title
                  }
                </span>
              )}
            </div>
            <div className="flex items-center gap-3">
              <span className="text-xs"> شماره : </span>
              {loading ? (
                <Skeleton width={100}></Skeleton>
              ) : (
                <span className="text-sm font-bold">{data.chSaleSoftID}</span>
              )}
            </div>
            <div className="flex items-center gap-3">
              <span className="text-xs"> تاریخ ثبت : </span>
              {loading ? (
                <Skeleton width={100}></Skeleton>
              ) : (
                <span className="text-sm font-bold">
                  {data.dInvoiceDate?.toLocaleDateString("fa")}
                </span>
              )}
            </div>
            <div className="flex items-center gap-3">
              <span className="text-xs"> موضوع : </span>
              {loading ? (
                <Skeleton width={100}></Skeleton>
              ) : (
                <span className="text-sm font-bold">
                  {data?.chInvoiceSubjectName}
                </span>
              )}
            </div>
            <div className="flex items-center gap-3">
              <span className="text-xs"> شماره مالیاتی : </span>
              {loading ? (
                <Skeleton width={100}></Skeleton>
              ) : (
                <span className="text-sm font-bold">{data?.chTaxID}</span>
              )}
            </div>
            <div className="flex items-center gap-3">
              <span className="text-xs"> آخرین وضعیت : </span>
              {loading ? (
                <Skeleton width={100}></Skeleton>
              ) : (
                <Box
                  sx={{
                    color: (theme) =>
                      data?.chLastWorkflowStepCode === "Sended"
                        ? "#81b1e7"
                        : data?.chLastWorkflowStepCode === "Failed"
                        ? "#ef7878"
                        : data?.chLastWorkflowStepCode === "Confirmed" ||
                          data?.chLastWorkflowStepCode === "BuyerConfirmed" ||
                          data?.chLastWorkflowStepCode === "SystemConfirmed"
                        ? "#33b151"
                        : data?.chLastWorkflowStepCode === "Rejected"
                        ? "#b1ab33"
                        : data?.chLastWorkflowStepCode === "NoNeededAction"
                        ? "#48fa73"
                        : data?.chLastWorkflowStepCode === "Canceled"
                        ? "#ed5c8a"
                        : theme.palette.mode === "dark"
                        ? "#fff"
                        : "#000",
                  }}
                  className="text-sm font-bold"
                >
                  {data?.chLastWorkflowStepName}
                </Box>
              )}
            </div>
            <div className="flex items-center gap-3">
              <span className="text-xs"> سریال داخلی : </span>
              {loading ? (
                <Skeleton width={100}></Skeleton>
              ) : (
                <span className="text-sm font-bold">{data?.intTaxSerial}</span>
              )}
            </div>
            <div className="flex items-center gap-3">
              <span className="text-xs"> زمان ارسال : </span>
              {loading ? (
                <Skeleton width={100}></Skeleton>
              ) : (
                <span className="text-sm font-bold">
                  {data?.dtSendDateTime}
                </span>
              )}
            </div>
            {data?.chIrTaxID && (
              <div className="flex items-center gap-3">
                <span className="text-xs"> شماره مالیاتی مرجع : </span>
                <span className="text-sm font-bold">{data?.chIrTaxID}</span>
              </div>
            )}
          </div>
        </div>
        <div className="flex flex-col gap-4 relative z-50">
          <div className="sm:grid sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 flex flex-col gap-4">
            <div className="sm:col-span-2  md:col-span-3 my-4  lg:col-span-4">
              <Divider>
                <h2 className="text-base font-bold text-center text-main">
                  اطلاعات فروشنده
                </h2>
              </Divider>
            </div>
            <div className="flex items-center gap-3">
              <span className="text-xs"> عنوان: </span>
              {loading ? (
                <Skeleton width={100}></Skeleton>
              ) : (
                <span className="text-sm font-bold">{data.chStateName}</span>
              )}
            </div>
            <div className="flex items-center gap-3">
              <span className="text-xs"> شناسه (کد) ملی: </span>
              {loading ? (
                <Skeleton width={100}></Skeleton>
              ) : (
                <span className="text-sm font-bold">{data.chEconomicCode}</span>
              )}
            </div>
            <div className="flex items-center gap-3">
              <span className="text-xs">کد پستی: </span>
              {loading ? (
                <Skeleton width={100}></Skeleton>
              ) : (
                <span className="text-sm font-bold">{data.chPostCode}</span>
              )}
            </div>
            {/*     <div className="flex items-center gap-3">
                <span className="text-xs"> شماره خریدار : </span>
                <span className="text-sm font-bold">{data.chBuyerTel}</span>
              </div> */}
          </div>{" "}
        </div>
        {data?.chInvoiceTypeCode !== "Type2" && (
          <div className="flex flex-col gap-4 relative z-50">
            <div className="sm:grid sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 flex flex-col gap-4">
              <div className="sm:col-span-2  md:col-span-3 my-4  lg:col-span-4">
                <Divider>
                  <h2 className="text-base font-bold text-center text-main">
                    اطلاعات خریدار
                  </h2>
                </Divider>
              </div>
              <div className="flex items-center gap-3">
                <span className="text-xs"> عنوان: </span>
                {loading ? (
                  <Skeleton width={100}></Skeleton>
                ) : (
                  <span className="text-sm font-bold">{data.chBuyerName}</span>
                )}
              </div>
              <div className="flex items-center gap-3">
                <span className="text-xs"> شناسه (کد) ملی: </span>
                {loading ? (
                  <Skeleton width={100}></Skeleton>
                ) : (
                  <span className="text-sm font-bold">
                    {data.chBuyerNationalID}
                  </span>
                )}
              </div>
              {/*     <div className="flex items-center gap-3">
                <span className="text-xs"> شماره خریدار : </span>
                <span className="text-sm font-bold">{data.chBuyerTel}</span>
              </div> */}
            </div>{" "}
          </div>
        )}
        <div className="flex flex-col gap-3 my-4">
          <div className="sm:grid sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 flex flex-col gap-4">
            <div className="sm:col-span-2  md:col-span-3  lg:col-span-4">
              <Divider>
                {" "}
                <h2 className="text-base font-bold text-center  text-main">
                  {" "}
                  اطلاعات ته جمع
                </h2>
              </Divider>
            </div>
            <div className="flex items-center gap-3">
              <span className="text-xs"> قبل از تخفیف : </span>
              {loading ? (
                <Skeleton width={100}></Skeleton>
              ) : (
                <span className="text-sm font-bold">
                  {data?.moTotalPriceBeforeDiscount?.toLocaleString("en-US")}
                </span>
              )}

              <small className="text-xs">ریال</small>
            </div>
            <div className="flex items-center gap-3">
              <span className="text-xs"> تخفیف : </span>
              {loading ? (
                <Skeleton width={100}></Skeleton>
              ) : (
                <span className="text-sm font-bold">
                  {data?.moTotalDiscount?.toLocaleString("en-US")}
                </span>
              )}
              <small className="text-xs">ریال</small>
            </div>
            {data.chInvoicePatternCode === "Jewelry" && (
              <>
                <div className="flex items-center gap-3">
                  <span className="text-xs">
                    {" "}
                    جمع کل اجرت ، حق العمل و سود :{" "}
                  </span>
                  {loading ? (
                    <Skeleton width={100}></Skeleton>
                  ) : (
                    <span className="text-sm font-bold">
                      {data?.moConsProfitWorkPrice?.toLocaleString("en-US")}
                    </span>
                  )}
                  <small className="text-xs">ریال</small>
                </div>
              </>
            )}
            <div className="flex items-center gap-3">
              <span className="text-xs"> مالیات : </span>
              {loading ? (
                <Skeleton width={100}></Skeleton>
              ) : (
                <span className="text-sm font-bold">
                  {data?.moTotalValueAddedPrice?.toLocaleString("en-US")}
                </span>
              )}
              <small className="text-xs">ریال</small>
            </div>
            <div className="flex items-center gap-3">
              <span className="text-xs"> مجموع صورتحساب : </span>
              {loading ? (
                <Skeleton width={100}></Skeleton>
              ) : (
                <span className="text-sm font-bold">
                  {data?.moTotalBillPrice?.toLocaleString("en-US")}
                </span>
              )}
              <small className="text-xs">ریال</small>
            </div>
          </div>
        </div>

        {/* part 4 */}
        <div className="sm:col-span-2  md:col-span-3 my-8  lg:col-span-4">
          <Divider>
            <h2 className="text-base font-bold text-center text-main">
              اطلاعات کالا
            </h2>
          </Divider>
        </div>

        <div className="sm:grid lg:grid-cols-4 md:grid-cols-3 sm:grid-cols-2 flex flex-col gap-3">
          {loading ? (
            <>
              {" "}
              <Skeleton
                variant="rounded"
                width={"100%"}
                animation="wave"
                height={140}
              />{" "}
              <Skeleton
                variant="rounded"
                width={"100%"}
                animation="wave"
                height={140}
              />{" "}
              <Skeleton
                variant="rounded"
                width={"100%"}
                animation="wave"
                height={140}
              />
            </>
          ) : (
            <>
              {" "}
              {seleted?.map((item, index) => (
                <Fragment key={index}>
                  <Box
                    className={`flex flex-col gap-4 border border-solid p-4 rounded-md `}
                  >
                    <ProductCart
                      data={
                        seleted.find((i) => i.guidRecNo === item?.guidRecNo) ||
                        item
                      }
                      noEdit
                      type={data.chInvoicePatternCode}
                    />
                  </Box>
                </Fragment>
              ))}
            </>
          )}
        </div>
      </Paper>
    </>
  );
};

export default PriviewInvoice;
const OPTIONS = {
  types: [
    {
      title: "نوع 1",
      id: "Type1",
    },
    {
      title: "نوع 2",
      id: "Type2",
    },
  ],
  pattern1: [
    {
      title: "فروش",
      id: "Sale",
    },
    {
      title: "فروش ارزی",
      id: "CurrSale",
    },
    {
      title: "طلا، جواهر و پلاتین",
      id: "Jewelry",
    },
    {
      title: "قرارداد پیمانکاری",
      id: "Contract",
    },
    {
      title: "قبوض خدماتی",
      id: "Service",
    },
    {
      title: "بلیت هواپیما",
      id: "Airfare",
    },
    {
      title: "صادرات",
      id: "Export",
    },
  ],
  pattern2: [
    {
      title: "فروش",
      id: "Sale",
    },

    {
      title: "طلا، جواهر و پلاتین",
      id: "Jewelry",
    },
  ],
  paymentType: [
    {
      title: "نقد",
      id: "Cash",
    },
    {
      title: "نسیه",
      id: "Credit",
    },
    {
      title: "نقد/نسیه",
      id: "CashCredit",
    },
  ],
};
